import Logo from "@/components/logo/logo";

export default function SideHeader(){
    return (
        <aside className="top-logo-layout">
            <Logo />
        </aside>
    )
}